/**
 * @generated SignedSource<<b1f89162ed8df2fe8d65d2bcac4cba1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getDrawingSetJobQuery$variables = {
  id: string;
};
export type getDrawingSetJobQuery$data = {
  readonly drawingSetJob: {
    readonly " $fragmentSpreads": FragmentRefs<"drawingSetJobFragment">;
  } | null | undefined;
};
export type getDrawingSetJobQuery = {
  response: getDrawingSetJobQuery$data;
  variables: getDrawingSetJobQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getDrawingSetJobQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetJob",
        "kind": "LinkedField",
        "name": "drawingSetJob",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "drawingSetJobFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getDrawingSetJobQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetJob",
        "kind": "LinkedField",
        "name": "drawingSetJob",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "drawingSetId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "finishedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stageProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stageStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b4c557cdecf332a2a40a8513c63fdf8d",
    "id": null,
    "metadata": {},
    "name": "getDrawingSetJobQuery",
    "operationKind": "query",
    "text": "query getDrawingSetJobQuery(\n  $id: ID!\n) {\n  drawingSetJob(id: $id) {\n    ...drawingSetJobFragment\n    id\n  }\n}\n\nfragment drawingSetJobFragment on DrawingSetJob {\n  id\n  createdAt\n  updatedAt\n  createdById\n  drawingSetId\n  finishedAt\n  jobProgress\n  jobStatus\n  stage\n  stageProgress\n  stageStatus\n  startedAt\n}\n"
  }
};
})();

(node as any).hash = "68d6ab0b2435adfc76089eec52ff0dd0";

export default node;
